const SITE_URL = "https://garcin.cl";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const REGIONAL_PAGES = {
  "es-CL": "/eos-en-chile",
  "es-PE": "/eos-peru",
  "es-CO": "/eos-colombia",
  "es-AR": "/eos-argentina",
  "es-UY": "/eos-uruguay",
  "es-EC": "/eos-ecuador",
  "es-PY": "/eos-paraguay",
};
const X_DEFAULT_PATH = "/implementador-eos";

// Solo las páginas regionales declaran hreflang; el resto limpia cualquier alternate previo.
function setHreflang(path) {
  document.querySelectorAll('link[rel="alternate"][data-hreflang]').forEach((el) => el.remove());
  if (!Object.values(REGIONAL_PAGES).includes(path)) return;
  const entries = [
    ...Object.entries(REGIONAL_PAGES),
    ["x-default", X_DEFAULT_PATH],
  ];
  entries.forEach(([lang, p]) => {
    const link = document.createElement("link");
    link.rel = "alternate";
    link.hreflang = lang;
    link.href = `${SITE_URL}${p}`;
    link.setAttribute("data-hreflang", "true");
    document.head.appendChild(link);
  });
}

function setMetaTag(selector, attr, value) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

/**
 * Sincroniza <title>, meta description/keywords, canonical y las etiquetas
 * Open Graph / Twitter Card con el contenido específico de cada página.
 * Se llama una vez por página dentro de un useEffect(() => {...}, []).
 * `path` debe incluir el "/" inicial, ej: "/que-es-eos".
 */
const DEFAULT_LOCALE = { lang: "es-CL", og: "es_CL" };
const DEFAULT_IMAGE_ALT = "Carlos Garcín — Implementador EOS Chile";

export function setPageSEO({ title, description, path, keywords, image, robots, locale, imageAlt }) {
  document.title = title;

  const loc = locale || DEFAULT_LOCALE;
  document.documentElement.lang = loc.lang;
  setMetaTag('meta[property="og:locale"]', "content", loc.og);
  setMetaTag('meta[property="og:image:alt"]', "content", imageAlt || DEFAULT_IMAGE_ALT);
  setMetaTag('meta[name="twitter:image:alt"]', "content", imageAlt || DEFAULT_IMAGE_ALT);

  let metaRobots = document.querySelector('meta[name="robots"]');
  if (!metaRobots) {
    metaRobots = document.createElement("meta");
    metaRobots.name = "robots";
    document.head.appendChild(metaRobots);
  }
  metaRobots.setAttribute("content", robots || "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1");

  setMetaTag('meta[name="description"]', "content", description);
  setMetaTag('meta[property="og:title"]', "content", title);
  setMetaTag('meta[property="og:description"]', "content", description);
  setMetaTag('meta[name="twitter:title"]', "content", title);
  setMetaTag('meta[name="twitter:description"]', "content", description);

  const url = `${SITE_URL}${path}`;
  setMetaTag('meta[property="og:url"]', "content", url);

  const ogImage = image || DEFAULT_OG_IMAGE;
  setMetaTag('meta[property="og:image"]', "content", ogImage);
  setMetaTag('meta[name="twitter:image"]', "content", ogImage);

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = url;

  setHreflang(path);

  if (keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", keywords);
  }
}
